import React from "react";
import { Link } from "react-router-dom";

import Modal from "../../atoms/Modal";
import { myDataPath } from "../../studentStore";
import qrStudentHomepage from "../../assets/images/qr_student_homepage.png";

import styles from "./StudentLoginQrCodeModal.module.scss";

export type Props = {
  onClose: () => void;
};

const StudentLoginQrCodeModal: React.FC<Props> = ({ onClose }) => {
  const loginUrl = `${process.env.REACT_APP_STUDENT_DLP_URL}/st/login`;
  return (
    <Modal onClose={onClose} className={styles.studentLoginQrCodeModal}>
      <img
        className={styles.qrCodeImage}
        src={qrStudentHomepage}
        alt="qr student homepage"
      />
      <a
        className={styles.url}
        href={loginUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        s.enageed.net
      </a>
      <p className={styles.note}>
        生徒がログインID/パスワードを忘れた場合は以下の手順でパスワードリセットしてください。
      </p>
      <br />
      <ul className={styles.noteList}>
        <li>
          1.左メニューの
          <Link aria-current="page" to={myDataPath}>
            [生徒個別データ]
          </Link>
          をクリックする。
        </li>
        <li>2.パスワードリセットしたい生徒を選択する。</li>
        <li>3.右上の[パスワードリセット]をクリックする。</li>
        <li>
          4.生徒名の下にある[ID]と表示された[仮パスワード]を生徒に共有する。
        </li>
      </ul>
    </Modal>
  );
};

export default StudentLoginQrCodeModal;
